import * as React from 'react'
require('../base.module.scss')
import * as cn from 'classnames'
import * as st from './Expander.module.scss'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import * as utils from '../../utils/utils'

interface ExpanderProps extends BaseComponentProps {
  numOfLines?: number,
  uniqueId?: string,
}

export const Expander: React.ComponentType<ExpanderProps> = (props: ExpanderProps) => {
  const className = extractClassNamesFromProps(props, st.expander)
  const { numOfLines = 1, uniqueId} = props
  const contentWrapperClass = cn(st.contentWrapper, st[`lines${numOfLines}`])
  const expanderId = uniqueId || utils.uniqueId()

  return <div className={className}>
    <input id={expanderId} className={st.checkbox} type="checkbox" />
    <label htmlFor={expanderId} className={st.label} />
    <div className={contentWrapperClass}>{props.children}</div>
  </div>
}

Expander.displayName = 'Expander'
